export const navigateTo = (url: string): void => {
  window.location.assign(url);
};
